/*
 * bpmbuild-uat-ds.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.11-SNAPSHOT
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/BuildingBean', 'model/FlowItemResponse', 'model/IKanbanBoard', 'model/KanbanBoard', 'model/LocationBean', 'model/SiteBean', 'model/StationResponse', 'model/WorkItemV2Response'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./BuildingBean'), require('./FlowItemResponse'), require('./IKanbanBoard'), require('./KanbanBoard'), require('./LocationBean'), require('./SiteBean'), require('./StationResponse'), require('./WorkItemV2Response'));
  } else {
    // Browser globals (root is window)
    if (!root.BpmbuildUatDsappspotcom) {
      root.BpmbuildUatDsappspotcom = {};
    }
    root.BpmbuildUatDsappspotcom.StationResponse = factory(root.BpmbuildUatDsappspotcom.ApiClient, root.BpmbuildUatDsappspotcom.BuildingBean, root.BpmbuildUatDsappspotcom.FlowItemResponse, root.BpmbuildUatDsappspotcom.IKanbanBoard, root.BpmbuildUatDsappspotcom.KanbanBoard, root.BpmbuildUatDsappspotcom.LocationBean, root.BpmbuildUatDsappspotcom.SiteBean, root.BpmbuildUatDsappspotcom.StationResponse, root.BpmbuildUatDsappspotcom.WorkItemV2Response);
  }
}(this, function(ApiClient, BuildingBean, FlowItemResponse, IKanbanBoard, KanbanBoard, LocationBean, SiteBean, StationResponse, WorkItemV2Response) {
  'use strict';

  /**
   * The StationResponse model module.
   * @module model/StationResponse
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>StationResponse</code>.
   * @alias module:model/StationResponse
   * @class
   */
  var exports = function() {
  };

  /**
   * Constructs a <code>StationResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/StationResponse} obj Optional instance to populate.
   * @return {module:model/StationResponse} The populated <code>StationResponse</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();
      if (data.hasOwnProperty('assetIdList'))
        obj.assetIdList = ApiClient.convertToType(data['assetIdList'], ['String']);
      if (data.hasOwnProperty('buildingBean'))
        obj.buildingBean = BuildingBean.constructFromObject(data['buildingBean']);
      if (data.hasOwnProperty('buildingId'))
        obj.buildingId = ApiClient.convertToType(data['buildingId'], 'String');
      if (data.hasOwnProperty('codeTag'))
        obj.codeTag = ApiClient.convertToType(data['codeTag'], 'String');
      if (data.hasOwnProperty('dateCreated'))
        obj.dateCreated = ApiClient.convertToType(data['dateCreated'], 'Date');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('errorCode'))
        obj.errorCode = ApiClient.convertToType(data['errorCode'], 'Number');
      if (data.hasOwnProperty('flowItemList'))
        obj.flowItemList = ApiClient.convertToType(data['flowItemList'], [FlowItemResponse]);
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('kanbanBoard'))
        obj.kanbanBoard = KanbanBoard.constructFromObject(data['kanbanBoard']);
      if (data.hasOwnProperty('kanbanBoardList'))
        obj.kanbanBoardList = ApiClient.convertToType(data['kanbanBoardList'], [IKanbanBoard]);
      if (data.hasOwnProperty('lastUpdatedDateTime'))
        obj.lastUpdatedDateTime = ApiClient.convertToType(data['lastUpdatedDateTime'], 'Date');
      if (data.hasOwnProperty('locationBean'))
        obj.locationBean = LocationBean.constructFromObject(data['locationBean']);
      if (data.hasOwnProperty('locationId'))
        obj.locationId = ApiClient.convertToType(data['locationId'], 'String');
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('operatingStatus'))
        obj.operatingStatus = ApiClient.convertToType(data['operatingStatus'], 'String');
      if (data.hasOwnProperty('postTaskIdList'))
        obj.postTaskIdList = ApiClient.convertToType(data['postTaskIdList'], ['String']);
      if (data.hasOwnProperty('preTaskIdList'))
        obj.preTaskIdList = ApiClient.convertToType(data['preTaskIdList'], ['String']);
      if (data.hasOwnProperty('qualityId'))
        obj.qualityId = ApiClient.convertToType(data['qualityId'], 'String');
      if (data.hasOwnProperty('requiresQualityCheck'))
        obj.requiresQualityCheck = ApiClient.convertToType(data['requiresQualityCheck'], 'Boolean');
      if (data.hasOwnProperty('responseMsg'))
        obj.responseMsg = ApiClient.convertToType(data['responseMsg'], 'String');
      if (data.hasOwnProperty('siteBean'))
        obj.siteBean = SiteBean.constructFromObject(data['siteBean']);
      if (data.hasOwnProperty('siteId'))
        obj.siteId = ApiClient.convertToType(data['siteId'], 'String');
      if (data.hasOwnProperty('stationList'))
        obj.stationList = ApiClient.convertToType(data['stationList'], [StationResponse]);
      if (data.hasOwnProperty('userId'))
        obj.userId = ApiClient.convertToType(data['userId'], 'String');
      if (data.hasOwnProperty('workItemList'))
        obj.workItemList = ApiClient.convertToType(data['workItemList'], [WorkItemV2Response]);
    }
    return obj;
  }

  /**
   * @member {Array.<String>} assetIdList
   */
  exports.prototype.assetIdList = undefined;

  /**
   * @member {module:model/BuildingBean} buildingBean
   */
  exports.prototype.buildingBean = undefined;

  /**
   * @member {String} buildingId
   */
  exports.prototype.buildingId = undefined;

  /**
   * @member {String} codeTag
   */
  exports.prototype.codeTag = undefined;

  /**
   * @member {Date} dateCreated
   */
  exports.prototype.dateCreated = undefined;

  /**
   * @member {String} description
   */
  exports.prototype.description = undefined;

  /**
   * @member {Number} errorCode
   */
  exports.prototype.errorCode = undefined;

  /**
   * @member {Array.<module:model/FlowItemResponse>} flowItemList
   */
  exports.prototype.flowItemList = undefined;

  /**
   * @member {String} id
   */
  exports.prototype.id = undefined;

  /**
   * @member {module:model/KanbanBoard} kanbanBoard
   */
  exports.prototype.kanbanBoard = undefined;

  /**
   * @member {Array.<module:model/IKanbanBoard>} kanbanBoardList
   */
  exports.prototype.kanbanBoardList = undefined;

  /**
   * @member {Date} lastUpdatedDateTime
   */
  exports.prototype.lastUpdatedDateTime = undefined;

  /**
   * @member {module:model/LocationBean} locationBean
   */
  exports.prototype.locationBean = undefined;

  /**
   * @member {String} locationId
   */
  exports.prototype.locationId = undefined;

  /**
   * @member {String} name
   */
  exports.prototype.name = undefined;

  /**
   * @member {String} operatingStatus
   */
  exports.prototype.operatingStatus = undefined;

  /**
   * @member {Array.<String>} postTaskIdList
   */
  exports.prototype.postTaskIdList = undefined;

  /**
   * @member {Array.<String>} preTaskIdList
   */
  exports.prototype.preTaskIdList = undefined;

  /**
   * @member {String} qualityId
   */
  exports.prototype.qualityId = undefined;

  /**
   * @member {Boolean} requiresQualityCheck
   */
  exports.prototype.requiresQualityCheck = undefined;

  /**
   * @member {String} responseMsg
   */
  exports.prototype.responseMsg = undefined;

  /**
   * @member {module:model/SiteBean} siteBean
   */
  exports.prototype.siteBean = undefined;

  /**
   * @member {String} siteId
   */
  exports.prototype.siteId = undefined;

  /**
   * @member {Array.<module:model/StationResponse>} stationList
   */
  exports.prototype.stationList = undefined;

  /**
   * @member {String} userId
   */
  exports.prototype.userId = undefined;

  /**
   * @member {Array.<module:model/WorkItemV2Response>} workItemList
   */
  exports.prototype.workItemList = undefined;

  return exports;

}));



// WEBPACK FOOTER //
// ./clientLibsUatds/src/model/StationResponse.js